.ui-skeleton-title {
  margin-block-start: 0;
}
